// biome-ignore-all lint/style/noMagicNumbers: these are all time constants

export const ONE_SECOND = 1000;
export const TWO_SECONDS = 2 * ONE_SECOND;
export const THREE_SECONDS = 3 * ONE_SECOND;
export const FIVE_SECONDS = 5 * ONE_SECOND;
export const TEN_SECONDS = 10 * ONE_SECOND;
export const THIRTY_SECONDS = 30 * ONE_SECOND;

export const ONE_MINUTE = 60 * ONE_SECOND;
export const FIVE_MINUTES = 5 * ONE_MINUTE;
export const THIRTY_MINUTES = 30 * ONE_MINUTE;

export const ONE_HOUR = ONE_MINUTE * 60;
export const ONE_DAY = ONE_HOUR * 24;
export const THREE_DAYS = ONE_DAY * 3;

export const MONTHS_IN_YEAR = 12;

/**
 * Whole-unit conversion factors, for code that works in seconds rather than milliseconds
 * (video timestamps, `maxAge` headers, WebVTT cues). Prefer these over re-deriving
 * `60 * 60` at the call site.
 */
export const SECONDS_PER_MINUTE = 60;
export const MINUTES_PER_HOUR = 60;
export const HOURS_PER_DAY = 24;
export const DAYS_PER_WEEK = 7;
export const SECONDS_PER_HOUR = SECONDS_PER_MINUTE * MINUTES_PER_HOUR;
export const SECONDS_PER_DAY = SECONDS_PER_HOUR * HOURS_PER_DAY;
